const yup = require('yup')
const { requiredFields, labelify } = require('./helpers')

const shape = labelify({
  name: yup.string().required().meta({ maxLength: 100 }).ensure(),
  shortCode: yup.string().ensure().max(3).meta({ maxLength: 3 }),
  createdAt: yup.date(),
  updatedAt: yup.date(),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
})

const eventLocationSchemaPartial = yup.object().shape(shape)
const eventLocationSchema = eventLocationSchemaPartial.shape(requiredFields(['name'])(shape))

module.exports = { eventLocationSchema, eventLocationSchemaPartial }
